import { AppConfigType, GlobalType } from '../types/config';

declare const global: GlobalType;

interface Env {
  env: string;
  pillarName?: string;
  appconfig: AppConfigType;
  parentHostname: string;
}

export const getAppConfig = (key?: string) => {
  const appconfig = global.appconfig || {};
  return key ? appconfig[key] : appconfig;
};

export const setAppConfig = (key: string, value: any) => {
  if (!global.appconfig) {
    global.appconfig = {};
  }
  global.appconfig[key] = value;
};

export const getEnvFromLocation = (location: Location): Env => {
  const { hostname = '' } = location || {};
  const pillarName = global.PILLAR_NAME;
  const appconfig = getAppConfig();
  const parentHostname = /alkemics\.com$/i.test(hostname)
    ? 'alkemics.com'
    : 'supplierxm.salsify.com';
  let env = 'prod';

  if (appconfig.env) {
    env = appconfig.env;
  } else if (
    pillarName ||
    hostname.endsWith(`.int.${parentHostname}`) ||
    hostname.endsWith(`.pillar.${parentHostname}`)
  ) {
    env = 'int';
  } else if (hostname.startsWith('ppr-')) {
    env = 'ppr';
  } else if (hostname.startsWith('ltg-')) {
    env = 'ltg';
  } else if (hostname.startsWith('alk-')) {
    env = 'alk';
  }

  return { env, pillarName, appconfig, parentHostname };
};

export const getEnv = (() => {
  let env: Env;
  return (): Env => {
    if (env) {
      return env;
    }
    env = getEnvFromLocation(global.document?.location);
    return env;
  };
})();
